<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="loading" v-if="loading"></div>
        <div class="close" v-on:click="close(false)"></div>
        <h4>{{title}}</h4>
        <div v-if="imported" class="imported">
          <h5>Import User Progress</h5>
          <p>You can check notification to check import user's
            status.</p>
          <button class="btn btnSecondary" v-on:click="close(true)">Close</button>
          <!--
          <h5>Upload Complete</h5>
          <p>{{imported.message}}</p>
          <button class="btn btnSecondary" v-on:click="close(true)">Close</button>
          <button class="btn btnPrimary" v-if="imported.status !== 200"
            v-on:click="tryAgain">Try Again</button>
          -->
        </div>
        <div v-else>
          <div :class="{dragArea: true, dragover: dragover, uploading: uploading,
            hasError: hasError}"
            v-on:drop.prevent="addFile" v-on:dragover.prevent
            v-on:dragstart="dragStart" v-on:dragenter="dragStart" v-on:dragend="dragEnd"
            v-on:dragexit="dragEnd" v-on:dragleave="dragEnd">
            <p>Drop .xlsx file here</p>
            <span>or</span>
            <button v-on:click="$refs.file.click()">Select File</button>
            <div class="uploadPorgress">
              <div class="theProgress">
                <div class="progressLabel" v-if="processing">
                  Processing...
                </div>
                <div class="progressLabel" v-else>
                  Uploading {{uploadPorgress}}%
                </div>
                <div :class="{progressBar: 1, processing: processing}">
                  <div class="pbin" :style="{width: `${uploadPorgress}%`}"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="errorLabel" v-if="hasError">{{errorMsg}}</div>
          <div class="help">
            <div>You can import .xlsx file based on template like example below.</div>
            <a :href="`${$config.apiHost}/documents/${templateFilename}`">
              Download template file</a>
            <img src="../assets/user-import-example.png">
          </div>
          <input type="file" ref="file" v-on:change="handleFile"
            style="display: none">
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      loading: false,
      dragover: false,
      uploading: false,
      processing: false,
      show: false,
      id: null,
      type: '',
      title: 'Import Users',
      next: null,
      theFile: null,
      uploadPorgress: 0,
      hasError: null,
      imported: null,
      errorMsg: '',
      templateFilename: '',
    };
  },
  methods: {
    open(d, next) {
      this.id = d.id;
      this.type = d.type;
      this.uploadPorgress = 0;
      this.theFile = null;
      this.hasError = null;
      this.imported = null;
      this.uploading = false;
      this.processing = false;
      this.next = next;
      this.show = true;
      if (d.type === 'event_guest_list') {
        this.templateFilename = 'event-guest-import-template.xlsx';
      }
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    tryAgain() {
      this.imported = null;
    },
    doUpload() {
      this.uploading = true;
      const formData = new FormData();
      formData.append('file', this.theFile);
      let uri = 'user/import';
      if (this.type === 'event_guest_list') {
        uri = `invitation/${this.id}/guest/upload`;
      }
      this.$http.post(this.$config.uri(uri), formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          this.uploadPorgress = Math.floor(progressEvent.loaded / progressEvent.total * 100);
          if (this.uploadPorgress >= 100) this.processing = true;
        },
      }).then((imgResponse) => {
        this.processing = false;
        this.uploading = false;
        if (imgResponse.data.status !== 200 && imgResponse.data.status !== 300) {
          this.hasError = true;
          this.errorMsg = (imgResponse.data.message) ? imgResponse.data.message : 'Only support xlsx file';
          return;
        }
        this.imported = true;
      });
    },
    handleFile() {
      this.hasError = false;
      if (this.uploading) return;
      [this.theFile] = this.$refs.file.files;
      this.doUpload();
    },
    addFile(e) {
      this.hasError = false;
      this.dragover = false;
      if (this.uploading) return;
      const droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      ([...droppedFiles]).forEach((f) => {
        this.theFile = f;
        this.doUpload();
      });
    },
    dragStart() {
      this.dragover = true;
      this.hasError = false;
    },
    dragEnd() {
      this.dragover = false;
      this.hasError = false;
    },
  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">
  .imported{
    text-align: center;
    background-color: #f5f5f5;
    padding: 40px 60px;
    border-radius: 5px;
    h5{
      margin: 0 0 4px;
      font-size: 20px;
    }
    p{
      line-height: 1.4;
    }
    .btn{
      margin: 16px 0 -20px !important;
      &.btnPrimary{
        margin-left: 10px !important;
      }
    }
  }
  .errorLabel{
    color: red;
    font-size: 13px;
    margin: 5px 0 0 5px;
  }
  .dragArea{
    padding: 40px 0;
    text-align: center;
    border: #ccc 4px dashed;
    position: relative;
    &.hasError{
      border-color: red;
    }
    .uploadPorgress{
      position: absolute;
      left: -4px; top: -4px; right: -4px; bottom: -4px;
      z-index: 1;
      border-radius: 5px;
      background-color: #eee;
      display: flex;
      justify-content: center;
      align-items: center;
      display: none;
      .progressLabel{
        font-size: 15px;
        color: #767676;
      }
      .progressBar{
        background-color: #ddd;
        height: 12px;
        width: 200px;
        margin-top: 10px;
        border-radius: 50px;
        .pbin{
          height: 100%;
          background-color: #ed1d51;
          background-image: linear-gradient(45deg, #ed1d51, #ffc875);
          border-radius: 50px;
          transition: width .3s linear;
        }
        &.processing{
          .pbin{
            width: 100% !important;
            background-image: linear-gradient(45deg, #ed1d51, #ffc875, #ed1d51, #ffc875);
            animation: colorAnimation 3s infinite;
            @keyframes colorAnimation {
              0% {
                background-image: linear-gradient(45deg, #ed1d51, #ffc875, #ed1d51, #ffc875);
              }
              20% {
                background-image: linear-gradient(45deg, #ffc875, #ed1d51, #ffc875, #ed1d51);
              }
              40% {
                background-image: linear-gradient(45deg, #ed1d51, #ffc875, #ed1d51, #ffc875);
              }
              60% {
                background-image: linear-gradient(45deg, #ffc875, #ed1d51, #ffc875, #ed1d51);
              }
              100% {
                background-image: linear-gradient(45deg, #ed1d51, #ffc875, #ed1d51, #ffc875);
              }
            }
          }
        }
      }
    }
    &.uploading{
      border-color: #fff;
      .uploadPorgress{
        display: flex;
      }
    }
    &.dragover{
      border-color: #0057d8;
    }
    p{
      margin: 0;
      font-size: 17px;
      color: #444;
    }
    span{
      display: block;
      color: #767676;
      margin: 4px 0 6px;
    }
    button{
      border-radius: 3px;
      color: #fff;
      border: none;
      box-shadow: none;
      font-size: 16px;
      background-color: #0057d8;
      padding: 8px 16px;
      outline: 0;
      cursor: pointer;
      &:hover{
        background-color: #0067ff;
      }
    }
  }

  .help{
    margin-top: 20px;
    color: #767676;
    font-size: 15px;
    a{
      display: inline-block;
      padding: 5px 14px;
      margin: 6px 0 10px;
      border-radius: 50px;
      font-size: 15px;
      border: #ddd 1px solid;
      padding-left: 36px;
      position: relative;
      color: #444;
      cursor: pointer;
      &:hover{
        background-color: #eee;
      }
      &:before{
        content: "";
        position: absolute;
        left: 14px; top: 0; bottom: 0;
        width: 14px;
        background-image: url(../assets/download-o.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
    img{
      width: 100%;
      height: auto;
      border: #eee 1px solid;
      box-sizing: border-box;
    }
  }

  .userModal{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    padding: 40px 0;

    .fieldCnt.hasError{
      .field{
        border-color: red;
      }
    }
    .fieldCnt.hasPrefix{
      position: relative;
      .field{
        padding-left: 40px;
      }
      .fieldPrefix{
        position: absolute;
        left: 10px; top: 35px;
        z-index: 3;
        color: #767676;
      }
    }

    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
    }
    .modalContent{
      position: relative;
      z-index: 2;
      background: #fff;
      width: 260px;
      margin: auto;
      border-radius: 5px;
      padding: 40px 100px;
      overflow: hidden;
      transition: all .3s ease;
      .loading{
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        background-color: #fff;
        background-color: rgba(255,255,255,.7);
        backdrop-filter: saturate(180%) blur(20px);
        background-image: url(../assets/loading.svg);
        background-position: center;
        background-size: 70px auto;
        background-repeat: no-repeat;
        z-index: 9;
      }
      .close{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: 10px;
        top: 10px;
        opacity: .4;
        cursor: pointer;
        transition: all .2s linear;
      }
      .close:hover{
        background-color: #e5e5e5;
        opacity: .7;
      }
      .titleCnt{
        border-bottom: #ddd 1px solid;
        margin-right: -80px;
        padding-right: 80px;
      }
      .title{
        width: 100%;
        box-sizing: border-box;
        border: none;
        padding: 0;
        outline: 0;
        font-size: 30px;
        font-weight: normal;
        resize: none;
        height: auto;
        padding-bottom: 10px;
      }
      h4{
        font-size: 30px;
        margin: 0;
        margin-bottom: 20px;
      }
      .btnCnt{
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        margin: 0 -80px -40px;
        padding: 12px 30px 2px;
      }
      .btn{
        margin-left: 5px;
        margin-bottom: 10px;
        &.disabled{
          background-color: #ddd;
          color: #999;
          box-shadow: none;
          cursor: default;
        }
      }
    }
  }

  .modalContent.modalBig{
    width: 480px;
    padding: 40px 80px;
    .fieldGroupBos{
      display: flex;
      .fieldCnt{
        width: 100%;
      }
      .recomended{
        padding: 34px 0 0 30px;
        margin-left: auto;
        display: flex;
        label{
          display: block;
          margin: 0;
          margin-right: 14px;
          padding-top: 3px;
        }
        .toggle{
          background-color: #e5e5e5;
          border-radius: 50px;
          width: 40px;
          height: 26px;
          position: relative;
          cursor: pointer;
          &:hover{
            background-color: #ddd;
          }
          &:before{
            content: "";
            display: block;
            position: absolute;
            left: 3px; top: 3px;
            background-color: #fff;
            width: 20px; height: 20px;
            border-radius: 50%;
            transition: all .2s ease;
          }
          &.on{
            background-color: #0067ff;
            &:before{
              left: 16px;
            }
          }
        }
      }
    }
  }
</style>
